export const SET_BOOK_FILTER = "SET_BOOK_FILTER";
export const SET_DETAILS_FOR = "SET_DETAILS_FOR";
export const SET_TIME_RANGE = "SET_TIME_RANGE";
export const SET_LITE_MODE = "SET_LITE_MODE";
